import { getLearningSessionDisplay } from '@common/components/daily-activity/formatters/learningSession/RadialGaugeLearningSessionFormatter';
import { type merged_time_and_activity } from '@common/@types/prisma';

import { getPercetageValue } from '../../utils';
import { type StudentDayStats, type StudentPast40WeeksStats } from '../../model';

export const getStudentPast40WeeksStatsGroupedBySubject = (
  data: Array<merged_time_and_activity> | undefined,
  theme: any
): StudentPast40WeeksStats => {
  const results: StudentPast40WeeksStats = {};

  if (!data || !data.length) {
    return results;
  }

  for (let i = 0; i < data.length; i++) {
    const { date, subject } = data[i];

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [timeSpent, accuracy, correctQuestionsPersHour, mastery] = getLearningSessionDisplay(
      data[i],
      theme
    );

    const { actual, target } = mastery;

    const stats: StudentDayStats = {
      actual,
      target,
      completedPercentage: getPercetageValue(target, actual),
      mastered: actual >= target,
    };

    results[subject] = {
      ...results[subject],
      [date]: stats,
    };
  }

  return results;
};
